module.exports = __webpack_public_path__ + "img/pnp.8b87fbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mlstudio/pnp.svg
// module id = 4aMg
// module chunks = 39 44